import { render, staticRenderFns } from "./organizationAdd.vue?vue&type=template&id=4ea5bb76&"
import script from "./organizationAdd.vue?vue&type=script&lang=js&"
export * from "./organizationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports